<template>
    <Modal ref="modal" class="customer-history-modal" @closed="onCloseModal">
        <template #button="sp">
            <slot name="button" :show-modal="showModal"></slot>
        </template>
        <template #body="sp">
            <div>
                <div class="mb-2 d-flex align-items-center justify-content-between">
                    <span class="h4">
                        Historique
                    </span>
                    <button class="btn btn-success mb-2" @click="reload()">
                        <i class="fad fa-sync"></i> Rafraîchir
                    </button>
                </div>

                <table v-if="histories.length" class="table table-sm table-condensed table-striped">
                    <tbody>
                        <CustomerHistoryModalMessage
                            v-for="history in histories"
                            :key="history.id"
                            :history="history"
                            :now="now"
                            :customer="customer"
                        />
                    </tbody>
                </table>
                <div v-else-if="!loading" class="alert alert-info">
                    Aucun historique pour le moment
                </div>

                <div v-if="loading" class="alert alert-info">
                    <i class="fad fa-spinner fa-spin"></i> Chargement
                </div>
                <ErrorsZone v-else-if="errors" :errors="errors"/>

                <div v-if="nextPageUrl" class="mt-2">
                    <button class="btn btn-success mb-2" @click="loadNextPage()">
                        <i class="fad fa-arrow-alt-circle-down"></i> Voir les messages précédents
                    </button>
                </div>
            </div>
        </template>
        <template #footer="sp">
            <button class="btn btn-secondary" @click="sp.closeModal()">Fermer</button>
        </template>
    </Modal>
</template>

<script>
    import ErrorsZone from "./ErrorsZone";
    import Modal from "./Modal";
    import CustomerHistoryModalMessage from "./CustomerHistoryModalMessage"

    import {useGetLoader} from "./compositions/axios/loadingRequest";

    export default {
        components: {
            ErrorsZone,
            Modal,
            CustomerHistoryModalMessage,
        },

        setup() {
            const {
                loading,
                errors,
                load,
            } = useGetLoader();

            return {
                loading,
                errors,
                load,
            };
        },

        props: {
            customer: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                histories: [],
                now: global.moment().toDate(),
                nextPageUrl: null,
            };
        },

        async mounted() {
            setInterval(() => {
                this.now = global.moment().toDate();
            }, 30000);
        },

        methods: {
            async loadNextPage() {
                if (this.customer.id) {
                    const response = await this.load(this.nextPageUrl || `/espace-employes/clients/${this.customer.id}/historique`);
                    if (response.data) {
                        this.histories = [...this.histories, ...response.data];
                        this.nextPageUrl = response.next_page_url;
                    }
                }
            },

            async reload() {
                this.histories = [];
                this.nextPageUrl = null;
                this.loadNextPage();
            },

            async showModal() {
                this.$refs.modal.showModal();

                await this.reload();
            },

            closeModal() {
                this.histories = [];
                this.$refs.modal.closeModal();
            },

            onCloseModal() {
                this.$emit('closed');
            },
        },
    }
</script>

<style lang="scss">
.customer-history-modal {
    .modal-container {
        max-width: 90%;
        width: auto;
    }
}
</style>
